var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('div',{staticClass:"map-wrapper",class:{ active: _vm.show.map }},[_c('Map',{ref:"map",attrs:{"map-id":"attractionMap","ori-map-points":_vm.oriMapPoints,"trigger-layer":_vm.triggerLayer}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }